import { createI18n } from "vue-i18n";

import en_gn from "../locale/en_gn.json";
import ko_kr from "../locale/ko_kr.json";

const supportLocales = ["ko_kr", "en_gn"];
const envLocale = String(process.env.VUE_APP_I18N_LOCALE ?? "").toLowerCase();
const defaultLocale = supportLocales.includes(envLocale) ? envLocale : "ko_kr";

export default createI18n({
  legacy: false,
  locale: defaultLocale,
  globalInjection: true,
  fallbackLocale: "en_gn",

  messages: {
    en_gn,
    ko_kr,
  },
});
